/**
 * Boolean Control Component
 * Renders toggle or checkbox
 */

import React from 'react';
import { Box } from '@mui/material';
import { ControlComponentProps } from '../../../../types/ControlTypes';
import { BooleanSettings } from '../../../../types/ControlTypes';
import { BaseSwitch } from '../BaseSwitch';
import { LabelWithInfo } from './LabelWithInfo';

export const BooleanControl: React.FC<ControlComponentProps> = ({
  name,
  value,
  onChange,
  error,
  disabled,
  readonly,
  label,
  description,
  required,
  control,
}) => {
  const settings = control.settings as BooleanSettings;
  const style = settings?.style || 'toggle';

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <BaseSwitch
          checked={!!value}
          onChange={(checked) => onChange(checked)}
          disabled={disabled || readonly}
        />
        <LabelWithInfo
          label={label || settings?.label || name}
          description={description}
          required={required}
        />
      </Box>
      {error && <Box sx={{ color: 'error.main', fontSize: '0.75rem' }}>{error}</Box>}
    </Box>
  );
};

export default BooleanControl;
